import React, { useState } from "react";

import { getApiUrl } from "../../config/api";
import { formatMobileNumber, normalizeMobileNumber } from "../../utils/phoneNumber";
import { Styles } from "./style/requestFormStyle";

const initialForm = {
  customer_name: "",
  contact: "",
  request_text: "",
};

const RequestForm = () => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "", message: "" });

  const handleChange = (event) => {
    const { name, value } = event.target;
    const nextValue = name === "contact" ? normalizeMobileNumber(value) : value;

    setForm((currentForm) => ({ ...currentForm, [name]: nextValue }));
    setErrors((currentErrors) => ({ ...currentErrors, [name]: "" }));
    setSubmitStatus({ type: "", message: "" });
  };

  const validateForm = () => {
    const nextErrors = {};

    if (!form.customer_name.trim()) {
      nextErrors.customer_name = "نام و نام خانوادگی را وارد کنید.";
    }

    if (!form.contact.trim()) {
      nextErrors.contact = "شماره تماس را وارد کنید.";
    }

    if (!form.request_text.trim()) {
      nextErrors.request_text = "متن درخواست را وارد کنید.";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus({ type: "", message: "" });

    try {
      const response = await fetch(getApiUrl("ticket"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_name: form.customer_name.trim(),
          contact: form.contact.trim(),
          request_text: form.request_text.trim(),
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to submit ticket");
      }

      setForm(initialForm);
      setErrors({});
      setSubmitStatus({
        type: "success",
        message: "درخواست شما با موفقیت ثبت شد.",
      });
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: "ثبت درخواست با خطا مواجه شد. لطفاً دوباره تلاش کنید.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Styles>
      <section className="request-section" aria-labelledby="request-title">
        <div className="request-intro">
          <div className="request-label">ثبت درخواست آنلاین</div>
          <h2 id="request-title">درخواست خود را با ما در میان بگذارید</h2>
          <p>
            برای خرید و فروش ارز، طلا و سکه یا دریافت مشاوره، اطلاعات خود را
            ثبت کنید تا کارشناسان ما با شما تماس بگیرند.
          </p>
        </div>

        <form className="request-form" onSubmit={handleSubmit} noValidate>
          <div className="form-row">
            <div className="field">
              <label htmlFor="customer_name">نام و نام خانوادگی</label>
              <input
                id="customer_name"
                name="customer_name"
                type="text"
                value={form.customer_name}
                onChange={handleChange}
                className={errors.customer_name ? "invalid" : ""}
                placeholder="هادی اسدزاده"
                disabled={isSubmitting}
              />
              {errors.customer_name && <span className="field-error">{errors.customer_name}</span>}
            </div>

            <div className="field">
              <label htmlFor="contact">شماره تماس</label>
              <input
                id="contact"
                name="contact"
                type="tel"
                value={formatMobileNumber(form.contact)}
                onChange={handleChange}
                className={errors.contact ? "invalid" : ""}
                placeholder="0912 123 4567"
                dir="ltr"
                inputMode="numeric"
                maxLength="13"
                disabled={isSubmitting}
              />
              {errors.contact && <span className="field-error">{errors.contact}</span>}
            </div>
          </div>

          <div className="field">
            <label htmlFor="request_text">متن درخواست</label>
            <textarea
              id="request_text"
              name="request_text"
              value={form.request_text}
              onChange={handleChange}
              className={errors.request_text ? "invalid" : ""}
              placeholder="درخواست خرید سکه دارم"
              rows="5"
              disabled={isSubmitting}
            />
            {errors.request_text && <span className="field-error">{errors.request_text}</span>}
          </div>

          <div className="form-footer">
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "در حال ارسال..." : "ثبت درخواست"}
            </button>
            {submitStatus.message && (
              <div className={`submit-message ${submitStatus.type}`} role="status">
                {submitStatus.message}
              </div>
            )}
          </div>
        </form>
      </section>
    </Styles>
  );
};

export default RequestForm;
